import { render, staticRenderFns } from "./PredictionHighlight.vue?vue&type=template&id=35f9cb2e&scoped=true"
import script from "./PredictionHighlight.vue?vue&type=script&lang=js"
export * from "./PredictionHighlight.vue?vue&type=script&lang=js"
import style0 from "./PredictionHighlight.vue?vue&type=style&index=0&id=35f9cb2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f9cb2e",
  null
  
)

export default component.exports